import request from 'sb-request'
import constants from 'common/helpers/constants'

import productsQuery from './products.graphql'


const getCount = ({ gender, brands, tags, notes, rating, visibility }) =>
  request.get('rest/shop/count/filter', {
    query: {
      gender,
      filter: {
        brands,
        tags,
        notes,
        rating,
        visibility,
      },
    },
  })
    .then(({ count }) => count)

/**
 * @param filters
 * @param {string} filters.gender
 * @param {string} filters.category
 * @param {string[]} filters.brands
 * @param {string[]} filters.notes
 * @param {string[]} filters.tags
 * @param {Number} filters.rating
 * @param {string} filters.sort
 * @param {string} filters.visibility
 */
const fetch = (filters = {}) => {
  let { gender, category, groups, brands, notes, tags, rating, visibility, sort, types } = filters

  let params = {
    groups: Array.isArray(groups) ? groups : [ 'Perfume' ],
  }

  // categories mapped to product feed
  if (category === 'all') {
    params.productsFeed = constants.productsFeed.allPerfumes
  }
  else if (category === 'bestsellers') {
    params.productsFeed = constants.productsFeed.bestsellers
  }
  else if (category === 'newarrivals') {
    params.productsFeed = constants.productsFeed.newArrivals
  }
  else if (category === 'niche') {
    params.productsFeed = constants.productsFeed.niche
  }
  else if (category === 'retailValue150') {
    params.minimumRetailValue = 15000
    // we don't need to add category to the query
    category = null
  }

  // we show sorted fragrances with 4-5 rating for top rated category
  if (category === 'toprated') {
    rating = 4
    sort = 'REVIEWS_RATING'
    category = null
  }

  // sort by rating by default if rating filter is active
  if (rating && !sort) {
    sort = 'REVIEWS_RATING'
  }

  if (gender) {
    params.gender = gender
  }

  if (sort) {
    params.sorts = [ sort ]
  }

  if (rating) {
    params.rating = rating
  }

  if (category && category !== 'all') {
    // KOSTYL`!!!!
    // for bestsellers-all we should fetch all bestsellers from groups: HomeFragrance, Perfumes, Makeup, BathBody
    if (category === 'bestsellers-all') {
      params.groups  = [ 'HomeFragrance', 'Perfume', 'Makeup', 'BathBody' ]
      params.category = 'bestsellers'
    }
    else {
      params.category = category
    }
  }
  else {
    params = {
      ...params,
      types,
      visibility,
      brands,
      notes,
      tags,
    }
  }

  // remove empty params
  Object.keys(params).forEach((key) => {
    if (!params[key] || params[key].length === 0) {
      delete params[key]
    }
  })

  return request.post('graphql?name=fragrancesProducts', {
    body: {
      query: productsQuery,
      variables: {
        input: params,
      },
    },
    modifyResult: ({ products = [] }) => products.map(({ tradingItem, ...item }) => ({
      ...item,
      tradingId: tradingItem && tradingItem.id, // it should be `tradingItem && tradingItem.id` coz there is `tradingItem: null` in response
    })),
  })
}


export default {
  fetch,
  getCount,
}
